module.exports = __webpack_public_path__ + "img/advantage2.9b2251b7.png";